export default __webpack_public_path__ + "static/media/earnings_calculator.fa78df6b.png";